import { post as _post, get as _get } from "@aws-amplify/api";
import { Amplify } from "aws-amplify";

const parseApiName = () => {
  const config = Amplify.getConfig();
  const keys = Object.keys(config?.API?.REST || {});
  return keys?.[0] || "default";
};

export const get = async (path, options = {}) => {
  const { apiName = parseApiName(), options : _options, ...rest } = options;
  try {
    const { body: apiBody } = await _get({
      apiName: apiName || "default",
      path,
      ...rest,
      options: _options
    }).response;

    const data = await apiBody.json();
    return { data };
  } catch (error) {
    const statusCode =
      error.response?.statusCode ||
      error.statusCode ||
      (error.message?.includes("404") ? 404 : 500);
    const data = error?.message || error?.data || error?.error?.data || "An unknown error occurred";
    return {
      error: {
        status: statusCode,
        data
      },
    };
  }
};

export const post = async (path, body, options = {}) => {
  const { apiName = parseApiName(), headers = {}, stringify = true, ...rest } = options;
  try {
    const { body: apiBody } = await _post({
      apiName: apiName || "default",
      path,
      options: {
        body,
        headers: {
          "Content-Type": "application/json",
          ...(headers || {}),
        },
        ...rest,
      },
    }).response;

    if(stringify) {
      const data = await apiBody.json();
      return { data };
    }
    return apiBody
  } catch (error) {
    return { error: error.message || "Request failed" };
  }
};
